import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { EstimateModel, Invoice, InvoiceData, InvoiceModel, Patient, TransactionModel } from '@mmx/shared'
import { filter, Subject, takeUntil } from 'rxjs'

import { CollectPaymentDialogComponent } from './collect-payment-dialog.component'

@Component({
  selector: 'mmx-collect-payment-button',
  templateUrl: './collect-payment-button.component.html',
  standalone: false,
})
export class CollectPaymentButtonComponent implements OnDestroy {
  @Input()
  public estimate: EstimateModel

  @Input()
  public patient: Patient

  @Input()
  public disabled = false

  @Output()
  public newCharge = new EventEmitter<{ invoice: InvoiceModel, transaction: TransactionModel }>()

  constructor(
    private readonly dialog: MatDialog,
  ) {}

  public get eligibleInvoices(): InvoiceModel[] {
    return (this.estimate?.invoices || []).filter((inv) => inv.status !== Invoice.STATUS.VOID && inv.status !== Invoice.STATUS.DRAFT)
  }

  private onDestroy$ = new Subject<void>()

  public ngOnDestroy(): void {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }

  public openCharge(invoice: InvoiceData | InvoiceModel) {
    if (!invoice) {
      return
    }

    this.dialog.open(CollectPaymentDialogComponent, {
      width: '720px',
      data: {
        invoice: invoice instanceof InvoiceModel ? invoice : new InvoiceModel(invoice),
        patient: this.patient,
      },
    })
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        filter(Boolean),
      )
      .subscribe((newCharge) => this.newCharge.emit(newCharge))
  }
}
